module.exports = __webpack_public_path__ + "img/logo1-2.c9363830.png";